import { useNavigate } from "react-router-dom";
import {
  PlayIcon,
  ClockIcon,
  ChevronRightIcon,
  SparklesIcon,
} from "@heroicons/react/24/solid";
import { useState } from "react";
import SimpleLoader from "../../components/Loader/SimpleLoader";

const getYoutubeThumbnail = (link) => {
  const match = link?.match(/(?:youtu\.be\/|v=)([a-zA-Z0-9_-]{11})/);
  return match
    ? `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`
    : "https://via.placeholder.com/640x360/674DA2/ffffff?text=Видео";
};

const VideoCard = ({ video, index, formatGroup }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const thumbnail = getYoutubeThumbnail(video.link);
  const groupData = formatGroup(video.group);

  const isNew = () => {
    if (!video.created) return false;
    const createdDate = new Date(video.created);
    const now = new Date();
    const diffInDays = (now - createdDate) / (1000 * 60 * 60 * 24);
    return diffInDays <= 1;
  };
  return (
    <div
      onClick={() => navigate(`/zhattygular/${video.uuid}`)}
      className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-2 cursor-pointer"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
        <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 transform scale-0 group-hover:scale-100 transition-transform duration-300">
          <PlayIcon className="w-8 h-8 text-[#674da2] fill-current" />
        </div>
      </div>

      <div className="relative aspect-video overflow-hidden bg-gradient-to-br from-purple-100 to-purple-50">
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <SimpleLoader className="w-8 h-8" />
          </div>
        )}
        <img
          src={thumbnail}
          alt={video.label}
          onLoad={() => setImageLoaded(true)}
          className={`w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
        />
        <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-black/30 to-transparent" />
      </div>

      {/* Group badge */}
      <div
        className={`absolute top-3 left-3 ${groupData.bg} ${groupData.text} text-xs font-bold px-3 py-1.5 rounded-full shadow-lg backdrop-blur-sm flex items-center gap-1.5 z-30`}
      >
        <span className="text-base">{groupData.icon}</span>
        <span>{groupData.label}</span>
      </div>

      {/* "New" badge */}
      {isNew() && (
        <div className="absolute top-3 right-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow-lg flex items-center gap-1 z-30">
          <SparklesIcon className="w-3 h-3" />
          <span>Жаңа</span>
        </div>
      )}

      {/* Bottom content */}
      <div className="relative p-4 bg-white">
        <h3 className="font-bold text-gray-900 text-base mb-2 line-clamp-2 group-hover:text-[#674da2] transition-colors">
          {video.label || "Дамытушы жаттығу"}
        </h3>
        <div className="flex items-center justify-between text-xs text-gray-500">
          {/* <div className="flex items-center gap-1">
            <ClockIcon className="w-3 h-3" />
            <span>1-2 мин</span>
          </div> */}
          {/* <div className="flex items-center gap-1 text-[#674da2] opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="font-medium">Көру</span>
            <ChevronRightIcon className="w-3 h-3" />
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default VideoCard;
